import React, { createContext, useContext, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authMe, authLogin, authRegister } from '../api';

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const nextRoute = (u) => {
  if (!u) return '/login';
  if (u.is_admin) return '/admin';
  if (!u.onboarded) return '/onboarding';
  if (!u.is_paid) return '/bayar';
  return '/app/beranda';
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [couple, setCouple] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const me = await authMe();
    setUser(me.user); setCouple(me.couple);
    return me;
  };

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback will exchange session_id first.
    if (window.location.hash?.includes('session_id=')) { setLoading(false); return; }
    const token = localStorage.getItem('np_token');
    if (!token) { setLoading(false); return; }
    refresh().catch(() => { localStorage.removeItem('np_token'); }).finally(() => setLoading(false));
  }, []);

  const applyAuth = (token, u) => { localStorage.setItem('np_token', token); setUser(u); };

  const login = async (email, password) => {
    const { token, user } = await authLogin({ email, password });
    applyAuth(token, user);
    try { const me = await authMe(); setCouple(me.couple); } catch (e) {}
    return user;
  };

  const register = async (name, email, password) => {
    const { token, user } = await authRegister({ name, email, password });
    applyAuth(token, user);
    return user;
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/app/beranda';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = () => {
    localStorage.removeItem('np_token');
    setUser(null);
    setCouple(null);
    window.location.href = '/';
  };

  return (
    <AuthCtx.Provider value={{ user, couple, setCouple, setUser, loading, login, register, loginWithGoogle, applyAuth, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function RequireAuth({ children, paid = false, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-cream-100 text-sage-500" data-testid="auth-loading">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !user.is_admin) return <Navigate to={nextRoute(user)} replace />;
  if (paid && !user.is_admin && (!user.onboarded || !user.is_paid)) return <Navigate to={nextRoute(user)} replace />;
  return children;
}
